import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiCard } from '@/features/dashboard-finance/KpiCard';
import { formatInt } from '@/features/dashboard-finance/formatters';

/**
 * KPI do total de produtos de todos os tenants (contagem por collection group,
 * sem filtro de status).
 */
export function ProductsCountCard({ total }: { total: number }): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <KpiCard
      label={t('usageBasic.cards.products')}
      value={formatInt(total)}
      helperText={t('usageBasic.cards.productsHint')}
    />
  );
}
